import { lazy } from "react";
import { Route, Navigate } from "react-router-dom";
import { AppRoutes } from "@/infra/router";
import LazyPage from "@/infra/router/LazyPage";

const AccountSettingsPage = lazy(() => import("./AccountSettingsPage"));
const LanguageSettingsPage = lazy(() => import("./LanguageSettingsPage"));
const NotificationSettingsPage = lazy(() => import("./NotificationSettingsPage"));
const SoundSettingsPage = lazy(() => import("./SoundSettingsPage"));
const DataTransparencySettingsPage = lazy(() => import("./DataTransparencySettingsPage"));
const TermsAndConditionsSettingsPage = lazy(() => import("./TermsAndConditionsSettingsPage"));
const IFUSettingsPage = lazy(() => import("./IFUSettingsPage"));
const ReleaseNotesPage = lazy(() => import("./ReleaseNotesPage"));

export const settingsRoutes = [
  <Route
    key={AppRoutes.Settings}
    element={<Navigate replace to={AppRoutes.AccountSettings} />}
    path={AppRoutes.Settings}
  />,
  <Route
    key={AppRoutes.AccountSettings}
    path={AppRoutes.AccountSettings}
    element={<LazyPage element={<AccountSettingsPage />} />}
  />,

  <Route
    key={AppRoutes.LanguageSettings}
    path={AppRoutes.LanguageSettings}
    element={<LazyPage element={<LanguageSettingsPage />} />}
  />,
  <Route
    key={AppRoutes.NotificationSettings}
    path={AppRoutes.NotificationSettings}
    element={<LazyPage element={<NotificationSettingsPage />} />}
  />,
  <Route
    key={AppRoutes.SoundSettings}
    path={AppRoutes.SoundSettings}
    element={<LazyPage element={<SoundSettingsPage />} />}
  />,
  <Route
    key={AppRoutes.PrivacyPolicyAndDataTransparencySettings}
    path={AppRoutes.PrivacyPolicyAndDataTransparencySettings}
    element={<LazyPage element={<DataTransparencySettingsPage />} />}
  />,
  <Route
    key={AppRoutes.TermsAndConditionsSettings}
    path={AppRoutes.TermsAndConditionsSettings}
    element={<LazyPage element={<TermsAndConditionsSettingsPage />} />}
  />,
  <Route
    key={AppRoutes.IFUSettings}
    path={AppRoutes.IFUSettings}
    element={<LazyPage element={<IFUSettingsPage />} />}
  />,
  <Route
    key={AppRoutes.ReleaseNotes}
    path={AppRoutes.ReleaseNotes}
    element={<LazyPage element={<ReleaseNotesPage />} />}
  />,
];
